import React, { MouseEvent } from "react";
import Moment from "react-moment";
import Article from '../types/Article';
import { useNavigate } from "react-router-dom";
type NewsItemProps = {
  article: Article,
  standalone?: boolean,
  className?: string,
};
const NewsItem = ({ article, standalone, className }: NewsItemProps) => {
  const navigate = useNavigate();
  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    const el = e.currentTarget;
    const url = el.getAttribute('href');
    if (url) {
      navigate(url);
    }
  }
  const getHTML = (str: string): { __html: string } => ({ __html: str });
    return (
      <div className={className}>
        {(standalone && <h2>{article.title}</h2>)}
        {(!standalone && <h3><a onClick={handleClick} href={`/news/${article.id}`}>{article.title}</a></h3>)}

        <div className="uk-section">
          <div className="uk-container uk-container-small">
            <div dangerouslySetInnerHTML={getHTML(article.content)} />
            <p>
              <Moment format="MMM Do YYYY">{article.published_at}</Moment>
            </p>
          </div>
        </div>
      </div>
    );
 
};

export default NewsItem; 